// yasinSurah.js - Yasin Surəsi Mətni

export const yasinSurah = `1) Ya sin.

2) Vəl-Qur'anil-həkim.

3) İnnəkə ləminəl-mursəlin.

4) Əla siratin mustəqim.

5) Tənziləl-əzizir-rəhim.

6) Litunzirə qəvmən ma unzirə abauhum fəhum ğafilun.

7) Ləqəd həqqəl-qəvlu əla əksərihim fəhum la yu'minun.

8) İnna cəəlna fi ə'naqihim əğlalən fəhiyə iləl-əzqani fəhum muqməhun.

9) Və cəəlna min bəyni əydihim səddən və min xəlfihim səddən fəəğşəynahum fəhum la yubsirun.

10) Və səvaun ələyhim əənzərtəhum əm ləm tunzirhum la yu'minun.

11) İnnəma tunziru mənittəbəəz-zikrə və xəşiyər-Rəhmanə bil-ğəybi, fəbəşşirhu biməğfirətin və əcrin kərim.

12) İnna nəhnu nuhyil-məvta və nəktubu ma qəddəmu və asarəhum və kullə şəy'in əhsəynahu fi imamin mubin.

13) Vəzrib ləhum məsələn əshabəl-qəryəti iz caəhəl-mursəlun.

14) İz ərsəlna iləyhimusnəyni fəkəzzəbuhuma fəəzzəzna bisalisin fəqalu inna iləykum mursəlun.

15) Qalu ma əntum illa bəşərun misluna və ma ənzələr-Rəhmanu min şəy'in in əntum illa təkzibun.

16) Qalu Rəbbuna yə'ləmu inna iləykum ləmursəlun.

17) Və ma ələyna illəl-bələğul-mubin.

18) Qalu inna tətəyyərna bikum ləin ləm təntəhu lənərcumənnəkum vələyəməssənnəkum minna əzabun əlim.

19) Qalu tairukum məəkum əin zukkirtum bəl əntum qəvmun musrifun.

20) Və caə min əqsəl-mədinəti rəculun yəs'a qalə ya qəvmittəbiul-mursəlin.

21) İttəbiu mən la yəs'əlukum əcrən və Muhtədun.

22) Və ma liyə la ə'budul-ləzi fətərəni və iləyhi turcəun.

23) Əəttəxizu min dunihi alihətən in yuridnir-Rəhmanu bizurrin la tuğni ənni şəfaətuhum şəy'ən və la yunqizun.

24) İnni izən ləfi zəlalin mubin.

25) İnni aməntu birəbbikum fəsməun.

26) Qilədxulil-cənnətə qalə ya ləytə qəvmi yə'ləmun.

27) Bima ğəfərə li Rəbbi və cəələni minəl-mukrəmin.

28) Və ma ənzəlna əla qəvmihi min bə'dihi min cundin minəs-səmai və ma kunna munzilin.

29) İn kanət illa səyhətən vahidətən fəiza hum xamidun.

30) Ya həsrətən ələl-ibadi ma yə'tihim min rəsulin illa kanu bihi yəstəhziun.

31) Ələm yərəv kəm əhləkna qəbləhum minəl-qurunni ənnəhum iləyhim la yərciun.

32) Və in kullun ləmma cəmiun lədəyna muhzərun.

33) Və ayətun ləhumul-ərzul-məytətu əhyəynaha və əxrəcna minha həbbən fəminhu yə'kulun.

34) Və cəəlna fiha cənnatin min nəxilin və ə'nabin və fəccərna fiha minəl-uyun.

35) Liyə'kulu min səmərəhi və ma əmiləthu əydihim əfəla yəşkurun.

36) Subhanəlləzi xələqəl-əzvacə kulləha mimma tunbitul-ərzu və min ənfusihim və mimma la yə'ləmun.

37) Və ayətun ləhumul-ləylu nəsləxu minhun-nəharə fəiza hum muzlimun.

38) Vəş-şəmsu təcri limusəqqarın ləha zalikə təqdirul-əzizil-əlim.

39) Vəl-qəmərə qəddərnahumənazilə hətta adə kəl-urcunil-qədim.

40) Ləş-şəmsu yənbəği ləha ən tudrikəl-qəmərə və ləl-ləylu sabiqun-nəhari və kullun fi fələkin yəsbəhun.

41) Və ayətun ləhum ənna həməlna zurriyyətəhum fil-fulkil-məşhun.

42) Və xələqna ləhum min mislihi ma yərkəbun.

43) Və in nəşə nuğriqhum fəla sərixə ləhum və la hum yunqəzun.

44) İlla rəhmətən minna və mətaən ila hin.

45) Və iza qilə ləhumuttəqqu ma bəynə əydikum və ma xəlfəkum ləəlləkum turhəmun.

46) Və ma tə'tihim min ayətin min ayati Rəbbihim illa kanu ənha mu'rizin.

47) Və iza qilə ləhum ənfiqu mimma rəzəqəkumullahu qaləlləzinə kəfəru lilləzinə am t'imu mən ləv yəşaullahu ət'əməhu in əntum illa fi zəlalin mubin.

48) Və yəqulunə məta hazəl-və'du in kuntum sadiqin.

49) Ma yənzurunə illa səyhətən vahidətən tə'xuzuhum və hum yəxissimun.

50) Fəla yəstətiunə təvsiyətən və la ila əhlihim yərciun.

51) Və nufixə fis-suri fəiza hum minəl-əcdasi ila Rəbbihim yənsilun.

52) Qalu ya vəyl mən bəəs min mərqədina, haza ma vəədər-Rəhmanu və sədəqəl-mursəlun.

53) İn kanət illa səyhətən vahidətən fəiza hum cəmiun lədəyna muhzərun.

54) Fəl-yəvmə la tuzləmu nəfsun şəy'ən və la tuczəvnə illa ma kuntum tə'məlun.

55) İnnə əshabəl-cənnətil-yəvmə fi şuğulin fakihun.

56) Hum və əzvacuhum fi zilalin ələl-əraiki muttəkiun.

57) Ləhum fiha fakihətun və ləhum ma yəddəun.

58) Səlamun qəvlən min Rəbbin rəhimin.

59) Vəmtazul-yəvmə əyyuhəl-mucrimun.

60) Ələm ə'həd iləykum ya bəni Adəmə ən la tə'buduş-şəytanə innəhu ləkum vun mubin.

61) Və əni'buduni haza siratun mustəqim.

62) Və ləqəd əzəllə minkum cibillən kəsirən əfələm təkunu tə'qilun.

63) Hazihi cəhənnəmul-ləti kuntum tun.

64) İsləvhəl-yəvmə bima kuntum təkfurun.

65) Əl-yəvmə nəxtimu əla əfvahihim və tukəllimuna əydihim və təşh ərculuhum bima kanu yəksibun.

66) Və ləv nəşau lətəməsna əla ə'yunihim fastəbəqus-ciratə fəənna yubsirun.

67) Və ləv nəşau ləməsəxnahum əla məkanətihim fəməstətau muziyyən və la yərciun.

68) Və mən nuəmmirhu nunəkkishu fil-xəlqi əfəla yə'qilun.

69) Və ma əlləmnahuş-şi'rə və ma yənbəği ləhu in huvə illa zikrun və Qur'anun mubin.

70) Liyunzirə mən kanə həyyən və yəhiqqəl-qəvlu ələl-kafirin.

71) Əvələm yərəv ənna xələqna ləhum mimma əmilət əydina ən'amən fəhum ləha malikun.

72) Və zəlləlnaha ləhum fəminha rəkubuhum və minha yə'kulun.

73) Və ləhum fiha mənafiu və məşaribu əfəla yəşkurun.

74) Vəttəxəzu min dunillahi alihətən ləəlləhum yunsərun.

75) La yəstətiunə nəsrəhum vəhum ləhum cundun muhzərun.

76) Fəla yəhzunkə qəvluhum, inna nə'ləmu ma yusirrunə və ma yu'linun.

77) Əvələm yərəl-insanu ənna xələqnahu min nutfətin fəiza huvə xəsimun mubin.

78) Və zərəbə lənə məsələn və nəsiyə xəlqəhu qalə mən yuhyil-izamə və hiyə rəmim.

79) Qul yuhyihəlləzi ənşəəha əvvələ mərrətin və huvə bikulli xəlqin əlim.

80) Əlləzi cəələ ləkum minəş-şəcəril-əxzəri narən fəiza əntum minhu tuqidun.

81) Əvələysəlləzi xələqəs-səmavati vəl-ərzə biqadirin əla ən yəxluqə misləhum, bəla vəhuvəl-xəllaqul-əlim.

82) İnnəma əmruhu iza əradə şəy'ən ən yəqulə ləhu kun fəyəkun.

83) Fəsubhanəlləzi biyədihi mələkutu kulli şəy'in və iləyhi turcə'un.`;

export default yasinSurah;